import { render } from "./ReportAdsTable.vue?vue&type=template&id=5009adae"
import script from "./ReportAdsTable.vue?vue&type=script&lang=js"
export * from "./ReportAdsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/ReportAdsTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5009adae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5009adae', __exports__)) {
    api.reload('5009adae', __exports__)
  }
  
  module.hot.accept("./ReportAdsTable.vue?vue&type=template&id=5009adae", () => {
    api.rerender('5009adae', render)
  })

}


export default __exports__